<template>
    <span class="tag bg-secondary"><slot></slot></span>
</template>

<script>
import "./Tag.scss";

export default {
    name: "Tag"
};
</script>
